var exports = {
  "ni": "IssueCommentLayout__fNsTnn",
  "KB": "IssueCommentContent__ViXx9n",
  "xC": "IssueCommentBody__DGWd7U",
};

module.exports = exports;
